export const baseStyles = {
    tabpanel: {
        py: 4,
    },
    tablist: {
        fontSize: 'sm',
    },
    tab: {
        fontSize: 'sm',
        textAlign: 'center',
        transitionProperty: 'common',
        transitionDuration: 'normal',
    },
};
